import React, { useState, createContext, useContext } from 'react';
interface UserContextType {
  role: 'admin' | 'broker' | 'compliance';
  setRole: (role: 'admin' | 'broker' | 'compliance') => void;
  hasPermission: (permission: string) => boolean;
}
const UserContext = createContext<UserContextType | undefined>(undefined);
export function UserProvider({
  children
}: {
  children: ReactNode;
}) {
  const [role, setRole] = useState<'admin' | 'broker' | 'compliance'>('broker');
  // Simple permission check based on role
  const hasPermission = (permission: string): boolean => {
    // Admin has all permissions
    if (role === 'admin') return true;
    // Role-based permissions
    const permissions: Record<string, string[]> = {
      broker: ['view_leads', 'create_lead', 'edit_lead', 'view_clients', 'create_client', 'edit_client', 'view_deals', 'create_deal', 'edit_deal', 'view_documents', 'upload_document', 'request_document', 'view_renewals', 'edit_renewal', 'view_communication', 'send_message', 'view_reports', 'track_time', 'view_commissions'],
      compliance: ['view_clients', 'view_deals', 'view_deal_details', 'view_documents', 'validate_document', 'view_renewals', 'view_reports', 'view_audit_log']
    };
    return permissions[role]?.includes(permission) || false;
  };
  return <UserContext.Provider value={{
    role,
    setRole,
    hasPermission
  }} data-id="element-717">
      {children}
    </UserContext.Provider>;
}
export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}